import { Avatar, Box, Button, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const SuperadminNavbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <Box sx={{ background: "#ffffff" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          px: 7,
        }}
      >
        {/* <div>Logo</div> */}
        <Box sx={{ display: "flex", columnGap: 20 }}>
          <Button
            className="btn-outlined"
            sx={{
              padding: "5px 60px !important",
              border: "1px solid #1a71f6",
            }}
            onClick={() => navigate("/superadmin-dashboard")}
          >
            Dashboard
          </Button>
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
            {storedUser.username}
            <Avatar
              {...stringAvatar(`Super Admin`)}
              onClick={handleAvatarClick}
              sx={{ cursor: "pointer" }}
            />
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SuperadminNavbar;
